import Vuex from 'vuex' 
 
import { get } from '@/api/AxiosUtils';
//共享状态（即变量）
const state  = {
    baseUrl :  '/addons/cms/wxapp.',
    apiUrl : 'http://api2.pxin1.com/',
    contactConfig:{
      phone:'425-449-2064',
      wechat:'Aaron-518618',
      phone2:'',
    },
    baseInfo:[],
    tabs:[
      {title:'微信',url:'icon-weixin',value:'Aaron-518618'},
      {title:'line',url:'icon-line',value:'taotao6688'},
      {title:'whatsapp',url:'icon-whatsapp',value:'425-449-2064'},
      {title:'短信',url:'icon-duanxin',value:'sms:（425）999-6464'},
    ],
    princessIndex:0,
    activeIndex:0,
    scrollHeight:0,
    princess:{},
    customerList:{},
    contactList:[],
    productList:[],
    // contactList:[{id:0,title:"title",infocontent:"info",picimages:"/uploads/20240324/24728c6c57e61b1e9038d1e2d07ba0fc.jpg,/uploads/20240324/24728c6c57e61b1e9038d1e2d07ba0fc.jpg"}],
    initCache:{
      archivesList:[],
      bannerList:[],
      tabList:[]
    },
    access : {
      name:'西雅图桃桃私人会所',
      icon:'el-icon-s-unfold',
      tokenKey : 'keyID123'
    },
    metaInfo:{
      title:'西雅图桃桃私人会所',
      keywords:'西雅图桃桃私人会所，桃桃私人会所',
      description:'西雅图桃桃私人会所是西雅图私人高级会所之一，你都可以在我们的网站找到你想要的享受。'
    }
  };
const mutations = {
    //修改meta关键字与描述
  CAHNGE_META_INFO(state, metaInfo) {
    state.metaInfo = metaInfo;
    console.log("----------"+state.metaInfo)
  },
  setPrincessIndex(state,index){ 
    state.princessIndex = index;
  },
  setActiveIndex(state,index){
    state.activeIndex = index; 
  },
  setCustomerList(state,customerList){
    state.customerList = customerList;
  },
  setContactList(state,contactList){
    state.contactList = contactList;
  },
  setBaseInfo(state,baseInfo){
    state.baseInfo = baseInfo;
  },
  setProductList(state,productList){
    state.productList = productList;
  },
}
const actions    = {
    updateActiveIndex(context,index){
      context.commit('setActiveIndex',index);
    },
    async fetchContactList(context)
    {
      try {
        const url = '/api/princess/getList';
        const response  =  await get(url,{},{}); 
        const data = response.data; 
        context.commit('setContactList',data); 
        // console.log("use fun ",state.contactList);
      } catch (error) {
        console.error('Network Error:', error);
      }
    }
}
const getters    = {
    getActiveIndex(state){
      return state.activeIndex;
    },
    getPrincessIndex(state){
      return state.princessIndex;
    },
    getContactList: state => state.contactList,
    // getContactById: (state) => (id) => {
      // console.log('--id :'+id)
      // if (!state.contactList || !Array.isArray(state.contactList)) {
      //   return null;
      // }
      // return state.contactList.find(contact => contact.id === id);
    // },
    getBlock: (state) => (id) => {
      // console.log('--id :'+id)
      if (!state.baseInfo.block || !Array.isArray(state.baseInfo.block)) {
        return null;
      }
      return state.baseInfo.find(block => block.status === id);
    }
    
}


export default new  Vuex.Store({
  state,
  mutations,
  actions,
  getters 
})